import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "0 0 90.6 107.3"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M85.7 20c-6.5 10.5-16.6 20.1-36.2 27.5-22.2 9.1-34.6 19.2-43.9 41.6 4-7.5 7-16.1 45.2-30.5 20.4-8.2 31.4-26.2 36-38.5l-1.1-.1Z",
      style: {"fill":"#dc3228"}
    }, null, -1),
    _createElementVNode("path", {
      d: "M43.9 65.7C21.7 74.8 9.3 84.9 0 107.3c4-7.5 7-16.1 45.2-30.5 20.4-8.2 31.4-26.2 36-38.5H80c-6.4 10.4-16.5 20-36.1 27.4ZM54.1 30c-20.8 8.5-32.5 18.1-41.2 39.1 3.7-7.1 6.6-15.2 42.5-28.7C76.8 31.8 87.2 11.7 90.6.3V0c-6 11.5-15.4 22.1-36.5 30Z",
      style: {"fill":"#262262"}
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "T3-logo"}) } }